import React from 'react';
import { Route, Switch } from 'react-router-dom';

import PinLock from 'components/core/PinLock.component';
import LoginWatcher from 'components/core/watchers/LoginWatcher.component';
import PinWatcher from 'components/core/watchers/PinWatcher.component';
import AccessPage from 'components/experiment/AccessPage.component';
import DatabasePage from 'components/experiment/DatabasePage.component';
import GiltPage from 'components/experiment/GiltPage.component';
import ActionsPage from 'components/experiment/hooks/ActionsPage.component';
import HooksPage from 'components/experiment/hooks/HooksPage.component';
import KpiPage from 'components/experiment/KpiPage.component';
import MiddlewarePage from 'components/experiment/MiddlewarePage.component';
import OnboardingPage from 'components/experiment/OnboardingPage.component';
import PosPage from 'components/experiment/PosPage.component';
import SentryPage from 'components/experiment/SentryPage.component';
import StripePage from 'components/experiment/StripePage.component';
import TimeFormatsPage from 'components/experiment/TimeFormatsPage.component';
import TimeOffPage from 'components/experiment/TimeOffPage.component';
import DatePanel from 'components/experiment/ui/DatePanel.component';
import FormPage from 'components/experiment/ui/FormPage.component';
import UiPage from 'components/experiment/ui/UiPage.component';
import UmsgPage from 'components/experiment/ui/UmsgPage.component';
import VoucherPage from 'components/experiment/VoucherPage.component';
import WizardPage from 'components/experiment/WizardPage.component';
import Space from 'components/generic/Space.component';
import withSalonId from 'components/hoc/withSalonId.hoc';
import CONF from 'config/conf.singleton';
import logger from 'utils/logger.util';
import { isValidId } from 'utils/predicates/fields.util';

import PayoutPage from './PayoutPage.component';

import CN from './Experiments.module.scss';

const L = logger('Experiments');

const ExperimentsPinWatcher = (props) => {
  // NOTE: in order to stop endless requests by the original Pin Watcher
  const salonId = props?.match?.params?.id;
  L.info('ExperimentsPinWatcher()', 'salonId:', salonId);
  return isValidId(salonId) ? <PinWatcher {...props} /> : null;
};

const Experiments = ({ currentSalonIdFromRedux }) => {
  if (!CONF.experiments) return null;

  L.info('()', 'Experiment pages are enabled');

  return (
    <>
      <Route path="/x" component={LoginWatcher} />
      <Route path="/x/form/onboarding" component={OnboardingPage} />
      <Route path="/x/time/formats" component={TimeFormatsPage} />
      <Route path="/x/ui/form" component={FormPage} />
      <Route path="/x/ui/page" component={UiPage} />
      <Route exact path="/x/ui" component={UiPage} />
      <Route exact path="/x/ui/date" component={DatePanel} />
      <Route path="/x/umsg" component={UmsgPage} />
      <Route path="/x/:id" component={ExperimentsPinWatcher} />
      <Switch>
        <PinLock>
          <Route path="/x/:id/access" component={AccessPage} />
          <Route path="/x/:id/actions" component={ActionsPage} />
          <Route path="/x/:id/db" component={DatabasePage} />
          <Route path="/x/:id/hooks" component={HooksPage} />
          <Route path="/x/:id/globalisation" component={GiltPage} />
          <Route path="/x/:id/kpi" component={KpiPage} />
          <Route path="/x/:id/mw" component={MiddlewarePage} />
          <Route path="/x/:id/onboarding" component={OnboardingPage} />
          <Route path="/x/:id/payout" component={PayoutPage} />
          <Route path="/x/:id/pos" component={PosPage} />
          <Route path="/x/:id/ui" component={UiPage} />
          <Route path="/x/:id/voucher/checkout" component={VoucherPage} />
          <Route path="/x/:id/wiz" component={WizardPage} />
          <Route path="/x/:id/timeoff" component={TimeOffPage} />
          <Route path="/x/:id/sentry" component={SentryPage} />
          <Route path="/x/:id/stripe" component={StripePage} />
        </PinLock>
      </Switch>
      <div data-bem="Experiments__tag" className={CN.tag}>
        <Space>EXPERIMENT</Space>
        <Space>w/</Space>
        <Space>salonId (from store): {currentSalonIdFromRedux}</Space>
      </div>
    </>
  );
};

const ExperimentsHoc = withSalonId(Experiments);

// noinspection JSUnusedGlobalSymbols
export default ExperimentsHoc;
